import { COMMERCIAL_DOCUMENT_LABELS, type CommercialDocumentInput } from "./commercial-documents";

export function commercialDocumentDetails(doc: CommercialDocumentInput): [string, string][] {
  return [
    ["Customer", doc.customerName],
    ["Reference", doc.reference],
    ["Tool", doc.toolName],
    ["Document date", doc.documentDate],
    ["Contact", doc.contactName],
    ["Contact email", doc.contactEmail],
    ["Initial term", doc.initialTerm],
    ["Expiration date", doc.expiresOn ?? ""],
    ["Original order", doc.originalReference],
  ].filter((row): row is [string, string] => Boolean(row[1]));
}
export function commercialDocumentSections(doc: CommercialDocumentInput) {
  return [
    { title: doc.kind === "change_order" ? "Changes to scope" : "Scope", text: doc.scope },
    { title: "Scope controls", text: doc.scopeControls },
    { title: "Timeline impact", text: doc.timelineImpact },
    { title: "Governing terms", text: doc.governingTerms },
  ].filter((section) => section.text.length > 0);
}
export function commercialDocumentFilename(doc: CommercialDocumentInput, revision: number | null) {
  const reference = doc.reference.replace(/[^a-zA-Z0-9_-]/g, "-").slice(0, 80) || "document";
  return `${COMMERCIAL_DOCUMENT_LABELS[doc.kind].toLowerCase().replaceAll(" ", "-")}-${reference}-${revision === null ? "draft" : `v${revision}`}.pdf`;
}
